import { render, staticRenderFns } from "./yearPowerCurve.vue?vue&type=template&id=0835563d&scoped=true&"
import script from "./yearPowerCurve.vue?vue&type=script&lang=js&"
export * from "./yearPowerCurve.vue?vue&type=script&lang=js&"
import style0 from "./yearPowerCurve.vue?vue&type=style&index=0&id=0835563d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835563d",
  null
  
)

export default component.exports